import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { VersionsListItem } from 'src/features/plan-version-sidebar/versions-list-item';
import Collapse, { Panel } from 'src/shared/components/collapse/collapse';
import type { TIntegrationPlansGroup } from 'src/store/comparison/types';

import styles from './integration-versions-group.module.scss';

type Props = {
  versionsGroup: TIntegrationPlansGroup;
};

export const IntegrationVersionsGroup = observer(function IntegrationVersionsGroup({ versionsGroup }: Props) {
  const { t } = useTranslation();

  if (!versionsGroup.months.length) {
    return null;
  }

  return (
    <Collapse key={versionsGroup.year} defaultActiveKey={versionsGroup.year}>
      <Panel key={versionsGroup.year} header={versionsGroup.year} className={styles.text}>
        {versionsGroup.months.map((monthGroup) => (
          <Collapse key={monthGroup.month} defaultActiveKey={monthGroup.month}>
            <Panel key={monthGroup.month} header={t(monthGroup.month)} className={styles.text}>
              <ul className={styles.versionsList}>
                {monthGroup.plans.map((plan) => {
                  return <VersionsListItem key={plan.id} version={plan} isRenamingAvailable={false} />;
                })}
              </ul>
            </Panel>
          </Collapse>
        ))}
      </Panel>
    </Collapse>
  );
});
